/**
 * Overlay ActionTypes
 */
export enum Actions {
  SHOW_OVERLAY = "SHOW_OVERLAY",
  HIDE_OVERLAY = "HIDE_OVERLAY",
}



// WEBPACK FOOTER //
// ./src/components/OverLay/store/Actions.tsx